import { useI18nSafe } from "./i18n-context";

type TranslationParams = Record<string, string | number>;

export function useTranslations(namespace?: string) {
  const { t, createScopedT } = useI18nSafe();

  if (!namespace) {
    return (key: string, params?: TranslationParams) => t(key, params);
  }

  const scopedT = createScopedT(namespace);
  return (key: string, params?: TranslationParams) => scopedT(key, params);
}
